import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'

export const KYB_UPLOAD_ENDPOINTS = {
  PROOF_OF_SECOND_HAND_DEALER_LICENCE:
    '/api/payout-experience/v1/kyb/proof-of-second-hand-dealer-licence',
  ARTICLE_OF_INCORPORATION:
    '/api/payout-experience/v1/kyb/article-of-incorporation',
  W9: '/api/payout-experience/v1/kyb/w9',
  PROOF_OF_IDENTITY:
    '/api/payout-experience/v1/kyb/stakeholders/:id/proof-of-identity',
  LETTER_OF_AUTHORIZATION:
    '/api/payout-experience/v1/kyb/letter-of-authorization/:stakeholderId',
} satisfies Record<string, keyof ApiSpecs>
